import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/Login.vue'

// Export routes so Layout/sidebar can build menus dynamically.
export const routes = [
  {
    path: '/',
    redirect: (to) => {
      const token = localStorage.getItem('token')
      if (token) return '/dashboard'
      return '/login'
    }
  },
  {
    path: '/login',
    name: 'Login',
    // 同步載入：避免 WebMonitor／內嵌瀏覽器無法載入 login 之 async chunk 時僅剩空 #app
    component: LoginView,
    meta: { title: '登入', public: true }
  },
  {
    path: '/dashboard',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { title: '首頁' }
      }
    ]
  },
  {
    path: '/transfer',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'receipt',
        name: 'TransferReceipt',
        component: () => import('../views/Transfer/Receiving.vue'),
        meta: { title: '調撥驗收' }
      },
      {
        path: 'return',
        name: 'TransferReturn',
        component: () => import('../views/Transfer/TransferReturn.vue'),
        meta: { title: '調撥單驗退' }
      },
      {
        path: 'shortage',
        name: 'TransferShortage',
        component: () => import('../views/Transfer/Shortage.vue'),
        meta: { title: '調撥短溢維護' }
      }
    ]
  },
  {
    path: '/stock-adjustment',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'inventory',
        name: 'StockAdjustment',
        component: () => import('../views/StockAdjustment/InventoryAdjustment.vue'),
        meta: { title: '庫存調整' }
      }
    ]
  },
  {
    path: '/inventory-check',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'stocktaking',
        name: 'InventoryCheck',
        component: () => import('../views/InventoryCheck/StocktakingPlan.vue'),
        meta: { title: '盤點維護' }
      }
    ]
  },
  {
    path: '/inventory',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'supplier-goods',
        name: 'SupplierGoods',
        component: () => import('../views/Inventory/SupplierGoods.vue'),
        meta: { title: '供應商商品維護' }
      },
      {
        path: 'product-goods-id',
        name: 'ProductGoodsId',
        component: () => import('../views/Inventory/ProductGoodsId.vue'),
        meta: { title: '商品進銷碼維護 (M-01-001)' }
      },
      {
        path: 'price-change',
        name: 'PriceChange',
        component: () => import('../views/Inventory/PriceChange.vue'),
        meta: { title: '商品永久變價 (M-01-002)' }
      },
      {
        path: 'pop-print',
        name: 'PopPrint',
        component: () => import('../views/Inventory/PopPrint.vue'),
        meta: { title: 'POP卡商品卡列印 (M-01-003)' }
      },
      {
        path: 'pop-print-ap',
        name: 'PopPrintAp',
        component: () => import('../views/Inventory/PopPrintAp.vue'),
        meta: { title: 'POP卡商品卡列印_AP (M-01-004)' }
      },
      {
        path: 'pop-print-ua',
        name: 'PopPrintUa',
        component: () => import('../views/Inventory/PopPrintUa.vue'),
        meta: { title: 'POP卡商品卡列印_UA (M-01-005)' }
      },
      {
        path: 'textfile-upload',
        name: 'TextFileUpload',
        component: () => import('../views/Inventory/TextFileUpload.vue'),
        meta: { title: 'BAT格式文本文件處理 - 文件上傳 (M-01-006)' }
      },
      {
        path: 'textfile-process-logs',
        name: 'TextFileProcessLogList',
        component: () => import('../views/Inventory/TextFileProcessLogList.vue'),
        meta: { title: 'BAT格式文本文件處理 - 處理記錄列表 (M-01-007)' }
      }
    ]
  },
  {
    path: '/purchase',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'order',
        name: 'PurchaseOrder',
        component: () => import('../views/Purchase/PurchaseOrder.vue'),
        meta: { title: '訂退貨申請' }
      },
      {
        path: 'order-v2',
        name: 'PurchaseOrderV2',
        component: () => import('../views/Purchase/PurchaseOrderV2.vue'),
        meta: { title: '訂退貨申請 (T-04-001)' }
      },
      {
        path: 'receipt',
        name: 'PurchaseReceipt',
        component: () => import('../views/Purchase/PurchaseReceipt.vue'),
        meta: { title: '採購單驗收 (T-04-002)' }
      },
      {
        path: 'receipt-v2',
        name: 'PurchaseReceiptV2',
        component: () => import('../views/Purchase/PurchaseReceiptV2.vue'),
        meta: { title: '採購單驗收 (T-04-003)' }
      },
      {
        path: 'settled-adjustment',
        name: 'SettledPurchaseReceiptAdjustment',
        component: () => import('../views/Purchase/SettledPurchaseReceiptAdjustment.vue'),
        meta: { title: '已日結採購單驗收調整 (T-04-004)' }
      },
      {
        path: 'closed-return-adjustment',
        name: 'ClosedReturnAdjustment',
        component: () => import('../views/Purchase/ClosedReturnAdjustment.vue'),
        meta: { title: '已日結退貨單驗退調整 (T-04-005)' }
      },
      {
        path: 'closed-return-adjustment-v2',
        name: 'ClosedReturnAdjustmentV2',
        component: () => import('../views/Purchase/ClosedReturnAdjustmentV2.vue'),
        meta: { title: '已日結退貨單驗退調整 (T-04-006)' }
      },
      {
        path: 'on-site-order',
        name: 'OnSitePurchaseOrder',
        component: () => import('../views/Purchase/OnSitePurchaseOrder.vue'),
        meta: { title: '現場打單 (T-04-007)' }
      },
      {
        path: 'query',
        name: 'PurchaseOrderQuery',
        component: () => import('../views/Purchase/PurchaseOrderQuery.vue'),
        meta: { title: '採購單查詢 (T-04-008)' }
      }
    ]
  },
  {
    path: '/customer',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'maintenance',
        name: 'CustomerMaintenance',
        component: () => import('../views/Customer/CustomerMaintenance.vue'),
        meta: { title: '客戶維護' }
      },
      {
        path: 'query',
        name: 'CustomerQuery',
        component: () => import('../views/Customer/CustomerQuery.vue'),
        meta: { title: '客戶查詢 (M-02-001)' }
      },
      {
        path: 'report',
        name: 'CustomerReport',
        component: () => import('../views/Customer/CustomerReport.vue'),
        meta: { title: '客戶報表 (M-02-002)' }
      }
    ]
  },
  {
    path: '/einvoice',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'process',
        name: 'EInvoiceProcess',
        component: () => import('../views/EInvoice/EInvoiceProcess.vue'),
        meta: { title: '電子發票處理 (E-01-002)' }
      },
      {
        path: 'query',
        name: 'EInvoiceQuery',
        component: () => import('../views/EInvoice/EInvoiceQuery.vue'),
        meta: { title: '電子發票查詢 (E-01-001)' }
      },
      {
        path: 'upload',
        name: 'EInvoiceUpload',
        component: () => import('../views/EInvoice/EInvoiceUpload.vue'),
        meta: { title: '電子發票上傳 (E-01-002)' }
      },
      {
        path: 'e-01-003-upload',
        name: 'E01003Upload',
        component: () => import('../views/EInvoice/E01003Upload.vue'),
        meta: { title: '電子發票上傳 (E-01-003)' }
      },
      {
        path: 'report',
        name: 'EInvoiceReport',
        component: () => import('../views/EInvoice/EInvoiceReport.vue'),
        meta: { title: '發票報表 (E-01-004)' }
      },
      {
        path: 'e-01-005-report',
        name: 'E01005Report',
        component: () => import('../views/EInvoice/E01005Report.vue'),
        meta: { title: '發票訂單報表 (E-01-005)' }
      },
      {
        path: 'e-01-006-report',
        name: 'E01006Report',
        component: () => import('../views/EInvoice/E01006Report.vue'),
        meta: { title: '商品銷售統計 (E-01-006)' }
      },
      {
        path: 'e-01-007-report',
        name: 'E01007Report',
        component: () => import('../views/EInvoice/E01007Report.vue'),
        meta: { title: '零售商銷售統計 (E-01-007)' }
      },
      {
        path: 'e-01-008-report',
        name: 'E01008Report',
        component: () => import('../views/EInvoice/E01008Report.vue'),
        meta: { title: '店別銷售統計 (E-01-008)' }
      },
      {
        path: 'e-01-009-report',
        name: 'E01009Report',
        component: () => import('../views/EInvoice/E01009Report.vue'),
        meta: { title: '出貨日期統計 (E-01-009)' }
      },
      {
        path: 'e-01-010-report',
        name: 'E01010Report',
        component: () => import('../views/EInvoice/E01010Report.vue'),
        meta: { title: '訂單日期統計 (E-01-010)' }
      },
    ]
  },
  {
    path: '/business-report',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'meal-cards',
        name: 'EmployeeMealCardList',
        component: () => import('../views/BusinessReport/EmployeeMealCardList.vue'),
        meta: { title: '員餐卡報表 (R-01-006)' }
      },
      {
        path: 'r-01-001',
        name: 'R01001Report',
        component: () => import('../views/BusinessReport/SYSL135Report.vue'),
        meta: { title: '業務報表 (R-01-001)' }
      },
      {
        path: 'r-01-002-query',
        name: 'R01002Query',
        component: () => import('../views/BusinessReport/SYSL145Query.vue'),
        meta: { title: '業務報表 (R-01-002)' }
      },
      {
        path: 'r-01-003-query',
        name: 'R01003Query',
        component: () => import('../views/BusinessReport/SYSL150Query.vue'),
        meta: { title: '業務報表列印 (R-01-003)' }
      },
      {
        path: 'r-01-004-print-log',
        name: 'R01004PrintLog',
        component: () => import('../views/BusinessReport/R01004PrintLog.vue'),
        meta: { title: '業務報表列印記錄 (R-01-004)' }
      },
      {
        path: 'employee-meal-card-fields',
        name: 'EmployeeMealCardFields',
        component: () => import('../views/BusinessReport/EmployeeMealCardFields.vue'),
        meta: { title: '員餐卡欄位管理 (R-01-005)' }
      },
      {
        path: 'employee-meal-card-reports',
        name: 'EmployeeMealCardReports',
        component: () => import('../views/BusinessReport/EmployeeMealCardReports.vue'),
        meta: { title: '員餐卡報表 (R-01-006)' }
      },
      {
        path: 'return-cards',
        name: 'ReturnCards',
        component: () => import('../views/BusinessReport/ReturnCards.vue'),
        meta: { title: '銷退卡管理 (R-01-007)' }
      },
      {
        path: 'overtime-payments',
        name: 'OvertimePayments',
        component: () => import('../views/BusinessReport/OvertimePayments.vue'),
        meta: { title: '加班發放管理 (R-01-008)' }
      },
      {
        path: 'r-01-009-query',
        name: 'R01009Query',
        component: () => import('../views/BusinessReport/SYSL160Query.vue'),
        meta: { title: '業務報表列印明細 (R-01-009)' }
      }
    ]
  },
  {
    path: '/analysis-report',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'query/:reportId?',
        name: 'AnalysisReportQuery',
        component: () => import('../views/AnalysisReport/AnalysisReportQuery.vue'),
        meta: { title: '進銷存分析報表' }
      },
      {
        path: 'consumable-label-print',
        name: 'ConsumableLabelPrint',
        component: () => import('../views/AnalysisReport/ConsumableLabelPrint.vue'),
        meta: { title: '耗材標籤列印 (R-02-001)' }
      },
      {
        path: 'consumable-report',
        name: 'ConsumableReportQuery',
        component: () => import('../views/AnalysisReport/ConsumableReportQuery.vue'),
        meta: { title: '耗材管理報表 (R-02-002)' }
      },
      {
        path: 'consumable-sales',
        name: 'ConsumableSalesList',
        component: () => import('../views/AnalysisReport/ConsumableSalesList.vue'),
        meta: { title: '耗材出售維護 (R-02-003)' }
      },
      {
        path: 'material-apply',
        name: 'MaterialApplyList',
        component: () => import('../views/AnalysisReport/MaterialApplyList.vue'),
        meta: { title: '單位領用申請 (R-02-004)' }
      },
      {
        path: 'r-02-005-report',
        name: 'SYSA1011Report',
        component: () => import('../views/AnalysisReport/SYSA1011Report.vue'),
        meta: { title: '商品分析報表 (R-02-005)' }
      },
      {
        path: 'r-02-006-report',
        name: 'SYSA1012Report',
        component: () => import('../views/AnalysisReport/SYSA1012Report.vue'),
        meta: { title: '進銷存月報表 (R-02-006)' }
      },
      {
        path: 'r-02-007-report',
        name: 'SYSA1013Report',
        component: () => import('../views/AnalysisReport/SYSA1013Report.vue'),
        meta: { title: '耗材出庫明細表 (R-02-007)' }
      },
      {
        path: 'r-02-008-report',
        name: 'SYSA1014Report',
        component: () => import('../views/AnalysisReport/SYSA1014Report.vue'),
        meta: { title: '商品分析報表 (R-02-008)' }
      },
      {
        path: 'r-02-009-report',
        name: 'SYSA1015Report',
        component: () => import('../views/AnalysisReport/SYSA1015Report.vue'),
        meta: { title: '商品分析報表 (R-02-009)' }
      },
      {
        path: 'r-02-010-report',
        name: 'SYSA1016Report',
        component: () => import('../views/AnalysisReport/SYSA1016Report.vue'),
        meta: { title: '商品分析報表 (R-02-010)' }
      },
      {
        path: 'r-02-011-report',
        name: 'SYSA1017Report',
        component: () => import('../views/AnalysisReport/SYSA1017Report.vue'),
        meta: { title: '商品分析報表 (R-02-011)' }
      },
      {
        path: 'r-02-012-report',
        name: 'SYSA1018Report',
        component: () => import('../views/AnalysisReport/SYSA1018Report.vue'),
        meta: { title: '工務維修件數統計表 (R-02-012)' }
      },
      {
        path: 'r-02-013-report',
        name: 'SYSA1019Report',
        component: () => import('../views/AnalysisReport/SYSA1019Report.vue'),
        meta: { title: '商品分析報表 (R-02-013)' }
      },
      {
        path: 'r-02-014-report',
        name: 'SYSA1020Report',
        component: () => import('../views/AnalysisReport/SYSA1020Report.vue'),
        meta: { title: '商品分析報表 (R-02-014)' }
      },
      {
        path: 'r-02-015-report',
        name: 'SYSA1021Report',
        component: () => import('../views/AnalysisReport/SYSA1021Report.vue'),
        meta: { title: '月成本報表 (R-02-015)' }
      },
      {
        path: 'r-02-016-report',
        name: 'SYSA1018ReportR0216',
        component: () => import('../views/AnalysisReport/SYSA1018Report.vue'),
        meta: { title: '工務維修件數統計表 (R-02-016)' }
      },
      {
        path: 'r-02-017-report',
        name: 'SYSA1022Report',
        component: () => import('../views/AnalysisReport/SYSA1022Report.vue'),
        meta: { title: '工務維修統計報表 (R-02-017)' }
      },
      {
        path: 'r-02-018-report',
        name: 'SYSA1023Report',
        component: () => import('../views/AnalysisReport/SYSA1023Report.vue'),
        meta: { title: '工務維修統計報表(報表類型) (R-02-018)' }
      },
      {
        path: 'r-02-018-other-report',
        name: 'SYSA1024Report',
        component: () => import('../views/AnalysisReport/SYSA1024Report.vue'),
        meta: { title: '工務維修統計報表(其他) (R-02-018)' }
      },
      {
        path: 'r-02-019-report',
        name: 'InventoryAnalysisReport',
        component: () => import('../views/AnalysisReport/InventoryAnalysisReport.vue'),
        meta: { title: '庫存分析報表 (R-02-019)' }
      },
      {
        path: 'r-02-020-report',
        name: 'SalesAnalysisReport',
        component: () => import('../views/AnalysisReport/SalesAnalysisReport.vue'),
        meta: { title: '銷售分析報表 (R-02-020)' }
      }
    ]
  },
  {
    path: '/system',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'permissions',
        redirect: '/system/role-permissions'
      },
      {
        path: 'role-permissions',
        name: 'SYS0310Query',
        component: () => import('../views/System/SYS0310Query.vue'),
        meta: { title: '角色系統權限設定 (S-01-001)' }
      },
      {
        path: 'user-permissions',
        name: 'SYS0320Query',
        component: () => import('../views/System/SYS0320Query.vue'),
        meta: { title: '使用者系統權限設定 (S-01-002)' }
      },
      {
        path: 'role-field-permissions',
        name: 'SYS0330Query',
        component: () => import('../views/System/SYS0330Query.vue'),
        meta: { title: '角色欄位權限設定 (S-01-003)' }
      },
      {
        path: 'user-field-permissions',
        name: 'SYS0340Query',
        component: () => import('../views/System/SYS0340Query.vue'),
        meta: { title: '使用者欄位權限設定 (S-01-004)' }
      },
      {
        path: 'item-permissions',
        name: 'SYS0360Query',
        component: () => import('../views/System/SYS0360Query.vue'),
        meta: { title: '系統對應權限設定 (S-01-005)' }
      },
      {
        path: 'system-config',
        name: 'SystemConfig',
        component: () => import('../views/System/SystemConfig.vue'),
        meta: { title: '系統設定 (S-01-006)' }
      },
      {
        path: 'systems',
        name: 'Systems',
        component: () => import('../views/System/Systems.vue'),
        meta: { title: '主系統項目維護 (S-01-007)' }
      },
      {
        path: 'programs',
        name: 'Programs',
        component: () => import('../views/System/Programs.vue'),
        meta: { title: '系統作業維護 (S-01-008)' }
      },
      {
        path: 'subsystems',
        name: 'SubSystems',
        component: () => import('../views/System/SubSystems.vue'),
        meta: { title: '子系統項目維護 (S-01-040)' }
      },
      {
        path: 'buttons',
        name: 'ConfigButtons',
        component: () => import('../views/System/ConfigButtons.vue'),
        meta: { title: '系統功能按鈕維護 (S-01-041)' }
      },
      {
        path: 'change-logs',
        name: 'ChangeLogs',
        component: () => import('../views/System/ChangeLogs.vue'),
        meta: { title: '異動記錄查詢 (S-01-009)' }
      },
      {
        path: 'users',
        name: 'SYS0110Query',
        component: () => import('../views/System/SYS0110Query.vue'),
        meta: { title: '使用者基本維護 (S-01-010)' }
      },
      {
        path: 'users-browse',
        name: 'SYS0120Query',
        component: () => import('../views/System/SYS0120Query.vue'),
        meta: { title: '使用者資料瀏覽 (S-01-011)' }
      },
      {
        path: 'users-query',
        name: 'SYS0140Query',
        component: () => import('../views/System/SYS0140Query.vue'),
        meta: { title: '使用者資料查詢 (S-01-012)' }
      },
      {
        path: 'users-query-sys0910',
        name: 'SYS0910Query',
        component: () => import('../views/System/SYS0910Query.vue'),
        meta: { title: '使用者查詢功能 (S-01-013)' }
      },
      {
        path: 'users-query-sys0140',
        redirect: (to) => ({ path: '/system/users-query', query: to.query })
      },
      {
        path: 'users-query-sys0140-old',
        redirect: (to) => ({ path: '/system/users-query', query: to.query })
      },
      {
        path: 'user-agents',
        name: 'SYS0117Query',
        component: () => import('../views/System/SYS0117Query.vue'),
        meta: { title: '使用者權限代理 (S-01-016)' }
      },
      {
        path: 'user-schedules',
        name: 'SYS0116Query',
        component: () => import('../views/System/SYS0116Query.vue'),
        meta: { title: '排程修改使用者基本資料 (S-01-017)' }
      },
      {
        path: 'login-log-query',
        name: 'SYS0760Query',
        component: () => import('../views/System/SYS0760Query.vue'),
        meta: { title: '使用者異常登入報表 (S-01-018)' }
      },
      {
        path: 'user-change-logs',
        name: 'SYS0610Query',
        component: () => import('../views/System/SYS0610Query.vue'),
        meta: { title: '使用者基本資料異動查詢 (S-01-019)' }
      },
      {
        path: 'role-change-logs',
        name: 'SYS0620Query',
        component: () => import('../views/System/SYS0620Query.vue'),
        meta: { title: '角色基本資料異動查詢 (S-01-020)' }
      },
      {
        path: 'user-role-change-logs',
        name: 'SYS0630Query',
        component: () => import('../views/System/SYS0630Query.vue'),
        meta: { title: '使用者角色對應設定異動查詢 (S-01-021)' }
      },
      {
        path: 'system-permission-change-logs',
        name: 'SYS0640Query',
        component: () => import('../views/System/SYS0640Query.vue'),
        meta: { title: '系統權限異動記錄查詢 (S-01-022)' }
      },
      {
        path: 'controllable-field-change-logs',
        name: 'SYS0650Query',
        component: () => import('../views/System/SYS0650Query.vue'),
        meta: { title: '可管控欄位異動記錄查詢 (S-01-023)' }
      },
      {
        path: 'other-change-logs',
        name: 'SYS0660Query',
        component: () => import('../views/System/SYS0660Query.vue'),
        meta: { title: '其他異動記錄查詢 (S-01-024)' }
      },
      {
        path: 'system-permission-list',
        name: 'SYS0710Query',
        component: () => import('../views/System/SYS0710Query.vue'),
        meta: { title: '系統權限列表 (S-01-025)' }
      },
      {
        path: 'user-account-policy',
        name: 'SYS0130Query',
        component: () => import('../views/System/SYS0130Query.vue'),
        meta: { title: '使用者帳戶原則管理 (S-01-026)' }
      },
      {
        path: 'roles',
        name: 'SYS0210Query',
        component: () => import('../views/System/SYS0210Query.vue'),
        meta: { title: '角色基本維護 (S-01-027)' }
      },
      {
        path: 'user-roles',
        name: 'SYS0220Query',
        component: () => import('../views/System/SYS0220Query.vue'),
        meta: { title: '使用者之角色設定維護 (S-01-028)' }
      },
      {
        path: 'role-users',
        name: 'SYS0230Query',
        component: () => import('../views/System/SYS0230Query.vue'),
        meta: { title: '角色之使用者設定維護 (S-01-029)' }
      },
      {
        path: 'role-copy',
        name: 'SYS0240Query',
        component: () => import('../views/System/SYS0240Query.vue'),
        meta: { title: '角色複製 (S-01-030)' }
      },
      {
        path: 'program-user-permissions',
        name: 'SYS0720Query',
        component: () => import('../views/System/ProgramUserPermissionReport.vue'),
        meta: { title: '作業權限之使用者列表 (S-01-031)' }
      },
      {
        path: 'role-system-permissions',
        name: 'SYS0731Query',
        component: () => import('../views/System/RoleSystemPermissionListReport.vue'),
        meta: { title: '角色系統權限列表 (S-01-032)' }
      },
      {
        path: 'program-role-permissions',
        name: 'SYS0740Query',
        component: () => import('../views/System/ProgramRolePermissionReport.vue'),
        meta: { title: '作業權限之角色列表 (S-01-033)' }
      },
      {
        path: 'role-user-list',
        name: 'SYS0750Query',
        component: () => import('../views/System/RoleUserListReport.vue'),
        meta: { title: '角色之使用者列表 (S-01-034)' }
      },
      {
        path: 'user-abnormal-login',
        redirect: (to) => ({ path: '/system/login-log-query', query: to.query })
      },
      {
        path: 'button-logs',
        name: 'SYS0790Query',
        component: () => import('../views/System/ButtonLogReport.vue'),
        meta: { title: '按鈕操作記錄查詢 (S-01-037)' }
      },
      {
        path: 'system-program-buttons',
        name: 'SYS0810Query',
        component: () => import('../views/System/SystemProgramButtonReport.vue'),
        meta: { title: '系統作業與功能列表查詢 (S-01-038)' }
      },
      {
        path: 'programs-and-buttons-export',
        name: 'SYS0999Query',
        component: () => import('../views/System/SystemProgramButtonExportQuery.vue'),
        meta: { title: '系統作業與功能列表查詢（出庫用）(S-01-039)' }
      }
    ]
  },
  {
    path: '/pos',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'transaction',
        name: 'PosTransaction',
        component: () => import('../views/Pos/Transaction.vue'),
        meta: { title: 'POS交易查詢' }
      },
      {
        path: 'report',
        name: 'PosReport',
        component: () => import('../views/Pos/Report.vue'),
        meta: { title: 'POS報表 (T-05-001)' }
      },
      {
        path: 'sync',
        name: 'PosSync',
        component: () => import('../views/Pos/Sync.vue'),
        meta: { title: 'POS資料同步 (T-05-002)' }
      }
    ]
  },
  {
    path: '/tools',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'file-upload',
        name: 'FileUpload',
        component: () => import('../views/Tools/FileUpload.vue'),
        meta: { title: '檔案上傳工具' }
      },
      {
        path: 'barcode',
        name: 'Barcode',
        component: () => import('../views/Tools/Barcode.vue'),
        meta: { title: '條碼處理工具 (O-01-001)' }
      },
      {
        path: 'html2pdf',
        name: 'Html2Pdf',
        component: () => import('../views/Tools/Html2Pdf.vue'),
        meta: { title: 'HTML轉PDF工具 (O-01-002)' }
      }
    ]
  },
  {
    path: '/kiosk',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'report',
        name: 'KioskReport',
        component: () => import('../views/Kiosk/Report.vue'),
        meta: { title: 'Kiosk報表' }
      },
      {
        path: 'process',
        name: 'KioskProcess',
        component: () => import('../views/Kiosk/Process.vue'),
        meta: { title: 'Kiosk資料處理 (O-02-001)' }
      }
    ]
  },
  {
    path: '/dropdown-list',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'address',
        name: 'AddressList',
        component: () => import('../views/DropdownList/AddressList.vue'),
        meta: { title: '地址列表' }
      },
      {
        path: 'date',
        name: 'DateList',
        component: () => import('../views/DropdownList/DateList.vue'),
        meta: { title: '日期列表 (B-01-001)' }
      },
      {
        path: 'menu',
        name: 'MenuList',
        component: () => import('../views/DropdownList/MenuList.vue'),
        meta: { title: '選單列表 (B-01-002)' }
      },
      {
        path: 'multi-select',
        name: 'MultiSelectList',
        component: () => import('../views/DropdownList/MultiSelectList.vue'),
        meta: { title: '多選列表 (B-01-003)' }
      },
      {
        path: 'system',
        name: 'SystemList',
        component: () => import('../views/DropdownList/SystemList.vue'),
        meta: { title: '系統列表 (B-01-004)' }
      },
      {
        path: 'user-list',
        name: 'UserList',
        component: () => import('../views/DropdownList/UserList.vue'),
        meta: { title: '使用者列表 (S-04-005)' }
      }
    ]
  },
  {
    path: '/communication',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'auto-process-mail',
        name: 'AutoProcessMail',
        component: () => import('../views/Communication/AutoProcessMail.vue'),
        meta: { title: '自動處理郵件' }
      },
      {
        path: 'encode-data',
        name: 'EncodeData',
        component: () => import('../views/Communication/EncodeData.vue'),
        meta: { title: '資料編碼 (E-02-001)' }
      },
      {
        path: 'mail-sms',
        name: 'MailSms',
        component: () => import('../views/Communication/MailSms.vue'),
        meta: { title: '郵件簡訊發送 (E-02-002)' }
      }
    ]
  },
  {
    path: '/ui-component',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'data-maintenance',
        name: 'DataMaintenance',
        component: () => import('../views/UiComponent/DataMaintenance.vue'),
        meta: { title: '資料維護UI組件' }
      },
      {
        path: 'query-report',
        name: 'QueryReport',
        component: () => import('../views/UiComponent/QueryReport.vue'),
        meta: { title: 'UI組件查詢與報表 (O-03-001)' }
      }
    ]
  },
  {
    path: '/report-extension',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'module-o',
        name: 'ReportModuleO',
        component: () => import('../views/ReportExtension/ModuleO.vue'),
        meta: { title: '報表模組O' }
      },
      {
        path: 'module-n',
        name: 'ReportModuleN',
        component: () => import('../views/ReportExtension/ModuleN.vue'),
        meta: { title: '報表模組N (R-03-001)' }
      },
      {
        path: 'module-wp',
        name: 'ReportModuleWP',
        component: () => import('../views/ReportExtension/ModuleWP.vue'),
        meta: { title: '報表模組WP (R-03-002)' }
      },
      {
        path: 'module-7',
        name: 'ReportModule7',
        component: () => import('../views/ReportExtension/Module7.vue'),
        meta: { title: '報表模組7 (R-03-003)' }
      },
      {
        path: 'print',
        name: 'ReportPrint',
        component: () => import('../views/ReportExtension/Print.vue'),
        meta: { title: '報表列印 (R-03-004)' }
      },
      {
        path: 'statistics',
        name: 'ReportStatistics',
        component: () => import('../views/ReportExtension/Statistics.vue'),
        meta: { title: '報表統計 (R-03-005)' }
      }
    ]
  },
  {
    path: '/core',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'user-management',
        name: 'UserManagement',
        component: () => import('../views/Core/UserManagement.vue'),
        meta: { title: '使用者管理' }
      },
      {
        path: 'framework',
        name: 'Framework',
        component: () => import('../views/Core/Framework.vue'),
        meta: { title: '框架功能 (S-02-001)' }
      },
      {
        path: 'tools',
        name: 'CoreTools',
        component: () => import('../views/Core/Tools.vue'),
        meta: { title: '工具功能 (S-02-002)' }
      },
      {
        path: 'system-function',
        name: 'SystemFunction',
        component: () => import('../views/Core/SystemFunction.vue'),
        meta: { title: '系統功能 (S-02-003)' }
      }
    ]
  },
  {
    path: '/other-module',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'crp-report',
        name: 'CrpReport',
        component: () => import('../views/OtherModule/CrpReport.vue'),
        meta: { title: 'CRP報表模組' }
      },
      {
        path: 'eip-integration',
        name: 'EipIntegration',
        component: () => import('../views/OtherModule/EipIntegration.vue'),
        meta: { title: 'EIP系統整合 (O-04-001)' }
      },
      {
        path: 'lab-test',
        name: 'LabTest',
        component: () => import('../views/OtherModule/LabTest.vue'),
        meta: { title: '實驗室測試功能 (O-04-002)' }
      }
    ]
  },
  {
    path: '/human-resource',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'personnel',
        name: 'Personnel',
        component: () => import('../views/HumanResource/Personnel.vue'),
        meta: { title: '人事管理' }
      },
      {
        path: 'payroll',
        name: 'Payroll',
        component: () => import('../views/HumanResource/Payroll.vue'),
        meta: { title: '薪資管理 (O-05-001)' }
      },
      {
        path: 'attendance',
        name: 'Attendance',
        component: () => import('../views/HumanResource/Attendance.vue'),
        meta: { title: '考勤管理 (O-05-002)' }
      }
    ]
  },
  {
    path: '/accounting',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'account-subject',
        name: 'AccountSubject',
        component: () => import('../views/Accounting/AccountSubject.vue'),
        meta: { title: '會計科目維護' }
      },
      {
        path: 'accounting',
        name: 'Accounting',
        component: () => import('../views/Accounting/Accounting.vue'),
        meta: { title: '會計管理 (O-06-001)' }
      },
      {
        path: 'financial-transaction',
        name: 'FinancialTransaction',
        component: () => import('../views/Accounting/FinancialTransaction.vue'),
        meta: { title: '財務交易 (O-06-002)' }
      },
      {
        path: 'asset',
        name: 'Asset',
        component: () => import('../views/Accounting/Asset.vue'),
        meta: { title: '資產管理 (O-06-003)' }
      },
      {
        path: 'financial-report',
        name: 'FinancialReport',
        component: () => import('../views/Accounting/FinancialReport.vue'),
        meta: { title: '財務報表 (O-06-004)' }
      },
      {
        path: 'other-financial',
        name: 'OtherFinancial',
        component: () => import('../views/Accounting/OtherFinancial.vue'),
        meta: { title: '其他財務功能 (O-06-005)' }
      }
    ]
  },
  {
    path: '/tax-accounting',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'accounting-subject',
        name: 'TaxAccountingSubject',
        component: () => import('../views/TaxAccounting/AccountingSubject.vue'),
        meta: { title: '會計科目維護' }
      },
      {
        path: 'accounting-voucher',
        name: 'AccountingVoucher',
        component: () => import('../views/TaxAccounting/AccountingVoucher.vue'),
        meta: { title: '會計憑證管理 (O-07-001)' }
      },
      {
        path: 'accounting-book',
        name: 'AccountingBook',
        component: () => import('../views/TaxAccounting/AccountingBook.vue'),
        meta: { title: '會計帳簿管理 (O-07-002)' }
      },
      {
        path: 'invoice-data',
        name: 'InvoiceData',
        component: () => import('../views/TaxAccounting/InvoiceData.vue'),
        meta: { title: '發票維護 (O-07-003)' }
      },
      {
        path: 'transaction-data',
        name: 'TransactionData',
        component: () => import('../views/TaxAccounting/TransactionData.vue'),
        meta: { title: '交易資料處理 (O-07-004)' }
      },
      {
        path: 'tax-report',
        name: 'TaxReport',
        component: () => import('../views/TaxAccounting/TaxReport.vue'),
        meta: { title: '稅務報表 (O-07-005)' }
      },
      {
        path: 'tax-report-print',
        name: 'TaxReportPrint',
        component: () => import('../views/TaxAccounting/TaxReportPrint.vue'),
        meta: { title: '稅務報表列印 (O-07-006)' }
      },
      {
        path: 'voucher-audit',
        name: 'VoucherAudit',
        component: () => import('../views/TaxAccounting/VoucherAudit.vue'),
        meta: { title: '暫存傳票審核 (O-07-007)' }
      },
      {
        path: 'voucher-import',
        name: 'VoucherImport',
        component: () => import('../views/TaxAccounting/VoucherImport.vue'),
        meta: { title: '傳票轉入 (O-07-008)' }
      }
    ]
  },
  {
    path: '/procurement',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'procurement',
        name: 'Procurement',
        component: () => import('../views/Procurement/Procurement.vue'),
        meta: { title: '採購管理 (T-06)' }
      },
      {
        path: 'supplier',
        name: 'ProcurementSupplier',
        component: () => import('../views/Procurement/Supplier.vue'),
        meta: { title: '供應商管理 (T-06-001)' }
      },
      {
        path: 'payment',
        name: 'ProcurementPayment',
        component: () => import('../views/Procurement/Payment.vue'),
        meta: { title: '付款單維護 (T-06-002)' }
      },
      {
        path: 'payment-voucher',
        name: 'ProcurementPaymentVoucher',
        component: () => import('../views/Procurement/PaymentVoucher.vue'),
        meta: { title: '付款單維護 (T-06-002)' }
      },
      {
        path: 'bank-management',
        name: 'ProcurementBankManagement',
        component: () => import('../views/Procurement/BankManagement/index.vue'),
        meta: { title: '銀行管理 (T-06-004)' }
      },
      {
        path: 'bank-account',
        name: 'ProcurementBankAccount',
        component: () => import('../views/Procurement/BankAccount.vue'),
        meta: { title: '銀行帳戶維護 (T-06-005)' }
      },
      {
        path: 'procurement-report',
        name: 'ProcurementReport',
        component: () => import('../views/Purchase/PurchaseReportQuery.vue'),
        meta: { title: '採購報表 (T-06-006)' }
      },
      {
        path: 'purchase-report-print',
        name: 'PurchaseReportPrint',
        component: () => import('../views/Procurement/PurchaseReportPrint.vue'),
        meta: { title: '採購報表列印 (T-06-007)' }
      },
      {
        path: 'report-print/history',
        name: 'PurchaseReportPrintHistory',
        component: () => import('../views/Procurement/PurchaseReportPrintHistory.vue'),
        meta: { title: '採購報表列印記錄 (T-06-008)' }
      },
      {
        path: 'procurement-other',
        name: 'ProcurementOther',
        component: () => import('../views/Procurement/ProcurementOther/index.vue'),
        meta: { title: '採購其他功能 (T-06-009)' }
      },
      {
        path: 'purchase-extended',
        name: 'PurchaseExtendedFunctions',
        component: () => import('../views/Procurement/PurchaseExtendedFunctions.vue'),
        meta: { title: '採購擴展功能 (T-06-010)' }
      },
      {
        path: 'purchase-extended-maintenance',
        name: 'PurchaseExtendedMaintenance',
        component: () => import('../views/Procurement/PurchaseExtendedMaintenance.vue'),
        meta: { title: '採購擴展維護 (T-06-011)' }
      }
    ]
  },
  {
    path: '/contract',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'contract-data',
        name: 'ContractData',
        component: () => import('../views/Contract/ContractData/index.vue'),
        meta: { title: '合同資料維護' }
      },
      {
        path: 'contract-process',
        name: 'ContractProcess',
        component: () => import('../views/Contract/ContractProcess/index.vue'),
        meta: { title: '合同處理 (E-03-001)' }
      },
      {
        path: 'contract-extension',
        name: 'ContractExtension',
        component: () => import('../views/Contract/ContractExtension/index.vue'),
        meta: { title: '合同擴展維護 (E-03-002)' }
      },
      {
        path: 'cms-contract',
        name: 'CmsContract',
        component: () => import('../views/Contract/CmsContract/index.vue'),
        meta: { title: 'CMS合同維護 (E-03-003)' }
      }
    ]
  },
  {
    path: '/lease',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'lease-data',
        name: 'LeaseData',
        component: () => import('../views/Lease/LeaseData/index.vue'),
        meta: { title: '租賃資料維護 (E-04)' }
      },
      {
        path: 'lease-extension',
        name: 'LeaseExtension',
        component: () => import('../views/Lease/LeaseExtension/index.vue'),
        meta: { title: '租賃擴展維護 (E-04-001)' }
      },
      {
        path: 'lease-process',
        name: 'LeaseProcess',
        component: () => import('../views/Lease/LeaseProcess/index.vue'),
        meta: { title: '租賃處理 (E-04-002)' }
      }
    ]
  },
  {
    path: '/lease-syse',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'lease-syse-data',
        name: 'LeaseSYSEData',
        component: () => import('../views/LeaseSYSE/LeaseSYSEData/index.vue'),
        meta: { title: '租賃資料維護 (E-04)' }
      },
      {
        path: 'lease-syse-extension',
        name: 'LeaseSYSEExtension',
        component: () => import('../views/LeaseSYSE/LeaseSYSEExtension/index.vue'),
        meta: { title: '租賃擴展維護 (E-04-003)' }
      },
      {
        path: 'lease-syse-fee',
        name: 'LeaseSYSEFee',
        component: () => import('../views/LeaseSYSE/LeaseSYSEFee/index.vue'),
        meta: { title: '費用維護 (E-04-004)' }
      }
    ]
  },
  {
    path: '/lease-sysm',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'lease-sysm-data',
        name: 'LeaseSYSMData',
        component: () => import('../views/LeaseSYSM/LeaseSYSMData/index.vue'),
        meta: { title: '租賃資料維護 (E-04)' }
      },
      {
        path: 'lease-sysm-report',
        name: 'LeaseSYSMReport',
        component: () => import('../views/LeaseSYSM/LeaseSYSMReport/index.vue'),
        meta: { title: '租賃報表 (E-04-005)' }
      }
    ]
  },
  {
    path: '/sales',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'sales-data',
        name: 'SalesData',
        component: () => import('../views/Sales/SalesData/index.vue'),
        meta: { title: '銷售資料維護' }
      },
      {
        path: 'sales-process',
        name: 'SalesProcess',
        component: () => import('../views/Sales/SalesProcess/index.vue'),
        meta: { title: '銷售處理 (T-07-001)' }
      },
      {
        path: 'sales-report',
        name: 'SalesReport',
        component: () => import('../views/Sales/SalesReport/index.vue'),
        meta: { title: '銷售報表 (T-07-002)' }
      }
    ]
  },
  {
    path: '/energy',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'energy-base',
        name: 'EnergyBase',
        component: () => import('../views/Energy/EnergyBase/index.vue'),
        meta: { title: '能源基礎維護 (O-08)' }
      },
      {
        path: 'energy-process',
        name: 'EnergyProcess',
        component: () => import('../views/Energy/EnergyProcess/index.vue'),
        meta: { title: '能源處理 (O-08-001)' }
      },
      {
        path: 'energy-extension',
        name: 'EnergyExtension',
        component: () => import('../views/Energy/EnergyExtension/index.vue'),
        meta: { title: '能源擴展維護 (O-08-002)' }
      }
    ]
  },
  {
    path: '/report-management',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'receiving-base',
        name: 'ReceivingBase',
        component: () => import('../views/ReportManagement/ReceivingBase/index.vue'),
        meta: { title: '收款基礎功能' }
      },
      {
        path: 'receiving-process',
        name: 'ReceivingProcess',
        component: () => import('../views/ReportManagement/ReceivingProcess/index.vue'),
        meta: { title: '收款處理功能 (R-04-001)' }
      },
      {
        path: 'receiving-extension',
        name: 'ReceivingExtension',
        component: () => import('../views/ReportManagement/ReceivingExtension/index.vue'),
        meta: { title: '收款擴展功能 (R-04-002)' }
      },
      {
        path: 'receiving-other',
        name: 'ReceivingOther',
        component: () => import('../views/ReportManagement/ReceivingOther/index.vue'),
        meta: { title: '收款其他功能 (R-04-003)' }
      }
    ]
  },
  {
    path: '/certificate',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'certificate-data',
        name: 'CertificateData',
        component: () => import('../views/Certificate/CertificateData/index.vue'),
        meta: { title: '憑證資料維護 (E-05)' }
      },
      {
        path: 'certificate-process',
        name: 'CertificateProcess',
        component: () => import('../views/Certificate/CertificateProcess/index.vue'),
        meta: { title: '憑證處理 (E-05-001)' }
      },
      {
        path: 'certificate-report',
        name: 'CertificateReport',
        component: () => import('../views/Certificate/CertificateReport/index.vue'),
        meta: { title: '憑證報表 (E-05-002)' }
      }
    ]
  },
  {
    path: '/extension',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'index',
        name: 'Extension',
        component: () => import('../views/Extension/index.vue'),
        meta: { title: '擴展功能維護' }
      }
    ]
  },
  {
    path: '/query',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'query',
        name: 'Query',
        component: () => import('../views/Query/Query/index.vue'),
        meta: { title: '查詢功能維護 (R-05)' }
      },
      {
        path: 'quality-base',
        name: 'QualityBase',
        component: () => import('../views/Query/QualityBase/index.vue'),
        meta: { title: '質量管理基礎功能 (R-05-001)' }
      },
      {
        path: 'quality-process',
        name: 'QualityProcess',
        component: () => import('../views/Query/QualityProcess/index.vue'),
        meta: { title: '質量管理處理功能 (R-05-002)' }
      },
      {
        path: 'quality-report',
        name: 'QualityReport',
        component: () => import('../views/Query/QualityReport/index.vue'),
        meta: { title: '質量管理報表功能 (R-05-003)' }
      }
    ]
  },
  {
    path: '/other-management',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'system-s',
        name: 'SystemS',
        component: () => import('../views/OtherManagement/SystemS/index.vue'),
        meta: { title: 'S系統功能維護' }
      },
      {
        path: 'system-u',
        name: 'SystemU',
        component: () => import('../views/OtherManagement/SystemU/index.vue'),
        meta: { title: 'U系統功能維護 (O-09-001)' }
      },
      {
        path: 'system-v',
        name: 'SystemV',
        component: () => import('../views/OtherManagement/SystemV/index.vue'),
        meta: { title: 'V系統功能維護 (O-09-002)' }
      },
      {
        path: 'system-j',
        name: 'SystemJ',
        component: () => import('../views/OtherManagement/SystemJ/index.vue'),
        meta: { title: 'J系統功能維護 (O-09-003)' }
      }
    ]
  },
  {
    path: '/customer-invoice',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'customer-data',
        name: 'CustomerData',
        component: () => import('../views/CustomerInvoice/CustomerData/index.vue'),
        meta: { title: '客戶資料維護 (E-07)' }
      },
      {
        path: 'invoice-print',
        name: 'InvoicePrint',
        component: () => import('../views/CustomerInvoice/InvoicePrint/index.vue'),
        meta: { title: '發票列印 (E-07-001)' }
      },
      {
        path: 'mail-fax',
        name: 'MailFax',
        component: () => import('../views/CustomerInvoice/MailFax/index.vue'),
        meta: { title: '郵件傳真 (E-07-002)' }
      },
      {
        path: 'ledger-data',
        name: 'LedgerData',
        component: () => import('../views/CustomerInvoice/LedgerData/index.vue'),
        meta: { title: '總帳維護 (E-07-003)' }
      }
    ]
  },
  {
    path: '/invoice-sales',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'invoice-data',
        name: 'InvoiceSalesInvoiceData',
        component: () => import('../views/InvoiceSales/InvoiceData/index.vue'),
        meta: { title: '發票資料維護' }
      },
      {
        path: 'invoice-print',
        name: 'InvoiceSalesInvoicePrint',
        component: () => import('../views/InvoiceSales/InvoicePrint/index.vue'),
        meta: { title: '電子發票列印 (E-08-001)' }
      },
      {
        path: 'sales-query',
        name: 'InvoiceSalesSalesQuery',
        component: () => import('../views/InvoiceSales/SalesQuery/index.vue'),
        meta: { title: '銷售查詢 (E-08-002)' }
      },
      {
        path: 'sales-report-query',
        name: 'InvoiceSalesSalesReportQuery',
        component: () => import('../views/InvoiceSales/SalesReportQuery/index.vue'),
        meta: { title: '報表 (E-08-003)' }
      },
      {
        path: 'sales-report-print',
        name: 'InvoiceSalesSalesReportPrint',
        component: () => import('../views/InvoiceSales/SalesReportPrint/index.vue'),
        meta: { title: '報表列印 (E-08-004)' }
      }
    ]
  },
  {
    path: '/invoice-sales-b2b',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'b2b-invoice-data',
        name: 'B2BInvoiceData',
        component: () => import('../views/InvoiceSalesB2B/B2BInvoiceData/index.vue'),
        meta: { title: 'B2B發票資料維護' }
      },
      {
        path: 'b2b-invoice-print',
        name: 'B2BInvoicePrint',
        component: () => import('../views/InvoiceSalesB2B/B2BInvoicePrint/index.vue'),
        meta: { title: 'B2B電子發票列印 (E-08-005)' }
      },
      {
        path: 'b2b-sales-data',
        name: 'B2BSalesData',
        component: () => import('../views/InvoiceSalesB2B/B2BSalesData/index.vue'),
        meta: { title: 'B2B銷售維護 (E-08-006)' }
      },
      {
        path: 'b2b-sales-query',
        name: 'B2BSalesQuery',
        component: () => import('../views/InvoiceSalesB2B/B2BSalesQuery/index.vue'),
        meta: { title: 'B2B銷售查詢 (E-08-007)' }
      }
    ]
  },
  {
    path: '/system-extension',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'maintenance',
        name: 'SystemExtension',
        component: () => import('../views/SystemExtension/SystemExtension.vue'),
        meta: { title: '系統擴展資料維護 (S-03)' }
      },
      {
        path: 'query',
        name: 'SystemExtensionQuery',
        component: () => import('../views/SystemExtension/SystemExtensionQuery.vue'),
        meta: { title: '系統擴展查詢 (S-03-001)' }
      },
      {
        path: 'report',
        name: 'SystemExtensionReport',
        component: () => import('../views/SystemExtension/SYSX140Report.vue'),
        meta: { title: '系統擴展報表 (S-03-002)' }
      }
    ]
  },
  {
    path: '/system-extension-e',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'employee-data',
        name: 'EmployeeData',
        component: () => import('../views/SystemExtensionE/EmployeeData/index.vue'),
        meta: { title: '員工資料維護' }
      },
      {
        path: 'personnel-data',
        name: 'PersonnelData',
        component: () => import('../views/SystemExtensionE/PersonnelData/index.vue'),
        meta: { title: '人事維護 (S-03-003)' }
      }
    ]
  },
  {
    path: '/system-extension-h',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'personnel-batch',
        name: 'PersonnelBatch',
        component: () => import('../views/SystemExtensionH/PersonnelBatch/index.vue'),
        meta: { title: '人事批量新增 (S-03)' }
      },
      {
        path: 'system-extension-ph',
        name: 'SystemExtensionPH',
        component: () => import('../views/SystemExtensionH/SystemExtensionPH/index.vue'),
        meta: { title: '感應卡維護 (S-03-004)' }
      }
    ]
  },
  {
    path: '/loyalty',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'init',
        name: 'LoyaltyInit',
        component: () => import('../views/Loyalty/LoyaltyInit/index.vue'),
        meta: { title: '忠誠度系統初始化' }
      },
      {
        path: 'maintenance',
        name: 'LoyaltyMaintenance',
        component: () => import('../views/Loyalty/LoyaltyMaintenance/index.vue'),
        meta: { title: '忠誠度系統維護 (O-10-001)' }
      }
    ]
  },
  {
    path: '/chart-tools',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'chart',
        name: 'Chart',
        component: () => import('../views/ChartTools/Chart/index.vue'),
        meta: { title: '圖表功能 (O-11)' }
      },
      {
        path: 'tools',
        name: 'ChartToolsTools',
        component: () => import('../views/ChartTools/Tools/index.vue'),
        meta: { title: '工具功能 (O-11-001)' }
      }
    ]
  },
  {
    path: '/system-exit',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: '',
        name: 'SystemExit',
        component: () => import('../views/SystemExit/index.vue'),
        meta: { title: '系統退出' }
      }
    ]
  },
  {
    path: '/customer-custom',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'cus3000',
        name: 'Cus3000',
        component: () => import('../views/CustomerCustom/Cus3000/index.vue'),
        meta: { title: '客戶定制模組 (O-99-001)' }
      },
      {
        path: 'cus3000-eskyland',
        name: 'Cus3000Eskyland',
        component: () => import('../views/CustomerCustom/Cus3000Eskyland/index.vue'),
        meta: { title: '客戶定制模組 (O-99-001)' }
      },
      {
        path: 'cus5000-eskyland',
        name: 'Cus5000Eskyland',
        component: () => import('../views/CustomerCustom/Cus5000Eskyland/index.vue'),
        meta: { title: '客戶定制模組 (O-99-002)' }
      },
      {
        path: 'cus-backup',
        name: 'CusBackup',
        component: () => import('../views/CustomerCustom/CusBackup/index.vue'),
        meta: { title: '客戶定制模組 (O-99-003)' }
      },
      {
        path: 'cus-cts',
        name: 'CusCts',
        component: () => import('../views/CustomerCustom/CusCts/index.vue'),
        meta: { title: '客戶定制模組 (O-99-004)' }
      },
      {
        path: 'cus-hanshin',
        name: 'CusHanshin',
        component: () => import('../views/CustomerCustom/CusHanshin/index.vue'),
        meta: { title: '客戶定制模組 (O-99-005)' }
      },
      {
        path: 'sys8000-eskyland',
        name: 'Sys8000Eskyland',
        component: () => import('../views/CustomerCustom/Sys8000Eskyland/index.vue'),
        meta: { title: '客戶定制模組 (O-99-006)' }
      }
    ]
  },
  {
    path: '/standard-module',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'std3000',
        name: 'Std3000',
        component: () => import('../views/StandardModule/Std3000/index.vue'),
        meta: { title: '標準模組 (O-99)' }
      },
      {
        path: 'std5000',
        name: 'Std5000',
        component: () => import('../views/StandardModule/Std5000/index.vue'),
        meta: { title: '標準模組 (O-99-007)' }
      }
    ]
  },
  {
    path: '/mir-module',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'mirh000',
        name: 'MirH000',
        component: () => import('../views/MirModule/MirH000/index.vue'),
        meta: { title: 'MIR 系列模組' }
      },
      {
        path: 'mirv000',
        name: 'MirV000',
        component: () => import('../views/MirModule/MirV000/index.vue'),
        meta: { title: 'MIR 系列模組 (O-99-008)' }
      },
      {
        path: 'mirw000',
        name: 'MirW000',
        component: () => import('../views/MirModule/MirW000/index.vue'),
        meta: { title: 'MIR 系列模組 (O-99-009)' }
      }
    ]
  },
  {
    path: '/msh-module',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'msh3000',
        name: 'Msh3000',
        component: () => import('../views/MshModule/Msh3000/index.vue'),
        meta: { title: 'MSH3000 模組' }
      }
    ]
  },
  {
    path: '/sap-integration',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'trans-sap',
        name: 'TransSap',
        component: () => import('../views/SapIntegration/TransSap/index.vue'),
        meta: { title: 'TransSAP 整合模組' }
      }
    ]
  },
  {
    path: '/universal-module',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'univ000',
        name: 'Univ000',
        component: () => import('../views/UniversalModule/Univ000/index.vue'),
        meta: { title: 'UNIV000 通用模組' }
      }
    ]
  },
  {
    path: '/customer-custom-jgjn',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'sys-cust-jgjn',
        name: 'SysCustJgjn',
        component: () => import('../views/CustomerCustomJgjn/SysCustJgjn/index.vue'),
        meta: { title: '客戶定制JGJN模組 (O-99)' }
      }
    ]
  },
  {
    path: '/communication-module',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'xcom',
        name: 'Xcom',
        component: () => import('../views/CommunicationModule/Xcom/index.vue'),
        meta: { title: 'XCOM000 通訊模組' }
      },
      {
        path: 'xcom-msg',
        name: 'XcomMsg',
        component: () => import('../views/CommunicationModule/XcomMsg/index.vue'),
        meta: { title: 'XCOMMSG 錯誤訊息處理 (E-02-003)' }
      }
    ]
  },
  {
    path: '/invoice-extension',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: '',
        name: 'InvoiceExtension',
        component: () => import('../views/InvoiceExtension/index.vue'),
        meta: { title: '電子發票擴展功能' }
      }
    ]
  },
  {
    path: '/sales-report',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'sales-report-module',
        name: 'SalesReportModule',
        component: () => import('../views/SalesReport/SalesReportModule/index.vue'),
        meta: { title: '銷售報表模組' }
      },
      {
        path: 'crystal-report',
        name: 'CrystalReport',
        component: () => import('../views/SalesReport/CrystalReport/index.vue'),
        meta: { title: 'Crystal Reports 報表功能 (R-02-021)' }
      }
    ]
  },
  {
    path: '/recruitment',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'prospect-masters',
        name: 'ProspectMasterList',
        component: () => import('../views/Recruitment/ProspectMasterList.vue'),
        meta: { title: '潛客主檔維護 (O-05-003)' }
      },
      {
        path: 'prospects',
        name: 'ProspectList',
        component: () => import('../views/Recruitment/ProspectList.vue'),
        meta: { title: '潛客維護 (O-05-003)' }
      },
      {
        path: 'interviews',
        name: 'InterviewList',
        component: () => import('../views/Recruitment/InterviewList.vue'),
        meta: { title: '訪談維護 (O-05-004)' }
      },
      {
        path: 'tenant-locations',
        name: 'TenantLocationList',
        component: () => import('../views/Recruitment/TenantLocationList.vue'),
        meta: { title: '招商其他功能 - 租戶位置維護 (O-05-005)' }
      }
    ]
  },
  {
    path: '/store-floor',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'store-management',
        name: 'StoreManagement',
        component: () => import('../views/StoreFloor/StoreManagement/index.vue'),
        meta: { title: '商店資料維護' }
      },
      {
        path: 'store-query',
        name: 'StoreQuery',
        component: () => import('../views/StoreFloor/StoreQuery/index.vue'),
        meta: { title: '商店報表 (M-03-001)' }
      },
      {
        path: 'floor',
        name: 'Floor',
        component: () => import('../views/StoreFloor/Floor/index.vue'),
        meta: { title: '樓層維護 (M-03-002)' }
      }
    ]
  },
  {
    path: '/master-data',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'product-categories',
        name: 'ProductCategories',
        component: () => import('../views/BasicData/ProductCategories.vue'),
        meta: { title: '商品分類資料維護 (M-03)' }
      },
      {
        path: 'departments',
        name: 'Departments',
        component: () => import('../views/BasicData/Departments.vue'),
        meta: { title: '部別維護 (M-03-003)' }
      },
      {
        path: 'parameters',
        name: 'Parameters',
        component: () => import('../views/BasicData/Parameters.vue'),
        meta: { title: '參數資料設定維護 (M-03-004)' }
      },
      {
        path: 'banks',
        name: 'Banks',
        component: () => import('../views/BasicData/Banks.vue'),
        meta: { title: '銀行基本維護 (M-03-005)' }
      },
      {
        path: 'regions',
        name: 'Regions',
        component: () => import('../views/BasicData/Regions.vue'),
        meta: { title: '地區設定 (M-03-006)' }
      },
      {
        path: 'departments',
        name: 'Departments',
        component: () => import('../views/BasicData/Departments.vue'),
        meta: { title: '部別維護 (M-03-003)' }
      },
      {
        path: 'warehouses',
        name: 'Warehouses',
        component: () => import('../views/BasicData/Warehouses.vue'),
        meta: { title: '庫別維護 (M-03-008)' }
      },
      {
        path: 'vendors',
        name: 'Vendors',
        component: () => import('../views/BasicData/Vendors.vue'),
        meta: { title: '廠/客基本維護 (M-03-009)' }
      },
      {
        path: 'groups',
        name: 'Groups',
        component: () => import('../views/BasicData/Groups.vue'),
        meta: { title: '組別維護 (M-03-010)' }
      },
      {
        path: 'areas',
        name: 'Areas',
        component: () => import('../views/BasicData/Areas.vue'),
        meta: { title: '區域基本維護 (M-03-011)' }
      },
      {
        path: 'vendors',
        name: 'Vendors',
        component: () => import('../views/BasicData/Vendors.vue'),
        meta: { title: '廠/客基本維護 (M-03-009)' }
      }
    ]
  },
  {
    path: '/customer',
    component: () => import('../views/Layout.vue'),
    children: [
      {
        path: 'customers',
        name: 'Customers',
        component: () => import('../views/Customer/Customers.vue'),
        meta: { title: '客戶維護' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    const main = document.querySelector('.layout-main')
    if (main) main.scrollTop = 0
    return { left: 0, top: 0 }
  }
})

// 未登入時導向登入頁（具 meta.public 的路由不檢查）
router.beforeEach((to, from, next) => {
  try {
    const wm = new URLSearchParams(window.location.search).get('s01006_wm') || ''
    if (wm.startsWith('WM_S01006_')) {
      sessionStorage.setItem('s01006QidSeed', 'WM_S01006')
    }
    let seed = to.query.s01006Qid
    seed = Array.isArray(seed) ? seed[0] : seed
    if (typeof seed !== 'string' || !seed.trim()) {
      seed = new URLSearchParams(window.location.search).get('s01006Qid') || ''
    }
    if (typeof seed !== 'string' || !seed.trim()) {
      const red = to.query.redirect
      const rpath = Array.isArray(red) ? red[0] : red
      if (typeof rpath === 'string' && (rpath.includes('s01006Qid') || rpath.includes('s01006_wm'))) {
        const qIdx = rpath.indexOf('?')
        if (qIdx >= 0) {
          const rq = new URLSearchParams(rpath.slice(qIdx + 1))
          seed = rq.get('s01006Qid') || ''
          const rwm = rq.get('s01006_wm') || ''
          if (!seed.trim() && rwm.startsWith('WM_S01006_')) {
            sessionStorage.setItem('s01006QidSeed', 'WM_S01006')
          }
        }
      }
    }
    if (typeof seed === 'string' && seed.trim()) {
      sessionStorage.setItem('s01006QidSeed', seed.trim())
    }
  } catch (_) {
    /* ignore */
  }
  const token = localStorage.getItem('token')
  if (to.meta.public) {
    if (token && to.path === '/login') {
      // WebMonitor／腳本：登入 URL 帶 wm_login（cache bust）時須見登入表單，勿因殘留 token 被導回首頁
      if (Object.prototype.hasOwnProperty.call(to.query, 'wm_login')) {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        next({ path: '/login', query: { ...to.query }, replace: true, hash: to.hash })
        return
      }
      next('/dashboard')
      return
    }
    next()
    return
  }
  if (!token) {
    next({ path: '/login', query: to.path !== '/' ? { redirect: to.fullPath } : {} })
    return
  }
  next()
})

export default router

